import React from "react";
import GenericPullAndPushToolView from "../GenericPullAndPushToolView";
import TenableScConfigListing from "./TenableScConfigListing";
import TenableScCredentialsForm from "./TenableScCredentialsForm";

export default function TenableScPullAndPushView(props) {
    return (
        <GenericPullAndPushToolView
            {...props}
            PullCredentialForm={TenableScCredentialsForm}
            PullConfigListingView={TenableScConfigListing}
        />
    )
}